namespace Serenity {
    export interface ScriptContext {
    }

    @Decorators.registerClass('Serenity.ScriptContext')
    export class ScriptContext {
    }
}
